module.exports = __webpack_public_path__ + "cglytics-teaser-ddf55c6b8dcca63832fd9e057dfa9a13.png";